import { render, staticRenderFns } from "./excomIcon.vue?vue&type=template&id=7b8a076a&"
import script from "./excomIcon.vue?vue&type=script&lang=js&"
export * from "./excomIcon.vue?vue&type=script&lang=js&"
import style0 from "./excomIcon.vue?vue&type=style&index=0&id=7b8a076a&prod&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports